/**
 * Human-readable name generators for devices and instances.
 */

const adjectives = [
  'amber', 'azure', 'bright', 'calm', 'cedar', 'clear', 'coral', 'crimson',
  'dusk', 'ember', 'fern', 'frost', 'gentle', 'golden', 'green', 'hollow',
  'iron', 'ivory', 'jade', 'keen', 'lemon', 'light', 'lunar', 'maple',
  'misty', 'moss', 'noble', 'north', 'olive', 'onyx', 'pale', 'pine',
  'quiet', 'rapid', 'river', 'rowan', 'ruby', 'sage', 'silver', 'slate',
  'solar', 'south', 'stone', 'swift', 'tawny', 'teal', 'terra', 'timber',
  'violet', 'warm', 'west', 'wild', 'winter', 'zinc',
]

const nouns = [
  'arrow', 'basin', 'birch', 'brook', 'canyon', 'cliff', 'cloud', 'crest',
  'crow', 'dawn', 'drift', 'dune', 'eagle', 'elm', 'falcon', 'field',
  'finch', 'flame', 'flint', 'fox', 'gate', 'grove', 'hawk', 'haven',
  'heron', 'hill', 'lark', 'leaf', 'marsh', 'meadow', 'mesa', 'oak',
  'orbit', 'otter', 'pass', 'peak', 'pond', 'rain', 'reef', 'ridge',
  'rock', 'sands', 'shore', 'spark', 'spring', 'star', 'stone', 'stream',
  'trail', 'vale', 'wave', 'willow', 'wind', 'wren',
]

function randomFrom(arr) {
  return arr[Math.floor(Math.random() * arr.length)]
}

/**
 * Generate a human-readable device name (e.g. "silver-falcon").
 * Persistent per device — stored in IndexedDB.
 */
export function generateDeviceName() {
  return `${randomFrom(adjectives)}-${randomFrom(nouns)}`
}

/**
 * Generate a short instance name (e.g. "tab-k7x2").
 * Ephemeral per session — stored in sessionStorage.
 */
export function generateInstanceName() {
  const chars = 'abcdefghjkmnpqrstuvwxyz23456789'
  let suffix = ''
  for (let i = 0; i < 4; i++) {
    suffix += chars[Math.floor(Math.random() * chars.length)]
  }
  return `tab-${suffix}`
}